import type { AppType } from '@workspace/api'
import { createCustomFetch } from '@workspace/utils/createCustomFetch'
import { hc } from 'hono/client'

import { useSupabaseClient } from './useSupabaseClient'

export function useApi() {
  const supabaseUrl = useNuxtApp().$config.public.supabase.url
  const supabaseClient = useSupabaseClient()
  // TODO: api-server の POST は非冪等なため、retry 判定を修正するまで無効化する
  const customFetch = createCustomFetch({ retryEnabled: false })
  const apiFetch: typeof fetch = async (input, init) => {
    const session = await supabaseClient.auth.getSession()
    const accessToken = session?.data.session?.access_token

    const headers = new Headers(init?.headers)
    if (accessToken) {
      headers.set('Authorization', `Bearer ${accessToken}`)
    }
    return await customFetch(input, {
      ...init,
      headers,
    })
  }
  const client = hc<AppType>(`${supabaseUrl}/functions/v1/`, {
    fetch: apiFetch,
  })['api-server']

  return { client }
}
